import { GetCredential } from "@/helper/documentFacadeHelper";
import { GetPndDocumentData } from "@/helper/pndHelper";
import { PndDocumentDetailModel, PndOnlineViewModel } from "@/model/document/pndDocumentModel";
import { SettingPndDocumentTemplateModel } from "@/model/document/settingDocumentTemplate";

export function ConvertToPndOnlineView(detail: any): PndOnlineViewModel {
  const onlineViewModel: PndOnlineViewModel = new PndOnlineViewModel();
  if (detail) {
    const documentDetailModel: PndDocumentDetailModel = new PndDocumentDetailModel();
    documentDetailModel.version = detail.document.version;
    documentDetailModel.data = GetPndDocumentData(detail.document.data);
    onlineViewModel.document = documentDetailModel;
    onlineViewModel.transactionId = detail.transactionId;
    onlineViewModel.transactionType = detail.transactionType;
    onlineViewModel.financeType = detail.financeType;
    onlineViewModel.expenseType = detail.expenseType;
    onlineViewModel.template = detail.template ? detail.template.data : GetPndSettingDocument();
    onlineViewModel.credential = GetCredential(detail.credential);
    onlineViewModel.headerOptionType = detail.headerOptionType;
  }

  return onlineViewModel;
}

export function GetPndSettingDocument(): SettingPndDocumentTemplateModel {
  let settingTemplate = new SettingPndDocumentTemplateModel();

  settingTemplate = {
    certified: {
      isShowUserCreateUrl: true,
      isShowUserApproveUrl: true,
      isShowUserCreateDate: true,
      isShowUserApproveDate: true,
      isShowUserApproveName: true,
      isShowUserCreateName: true,
      isShowMerchantStampUrl: true,
    },
  };

  return settingTemplate;
}
